import { validateIban } from "src/helpers/sanitizeInput";

interface OpenIbanResponse {
    valid: boolean;
    bankData?: { bic?: string };
}

// Looks up the BIC for a given IBAN via openiban.com.
// Returns the BIC string on success, null on failure or invalid IBAN.
export async function lookupBicFromIban(iban: string): Promise<string | null> {
    const cleaned = iban.replace(/\s/g, "").toUpperCase();
    if (!validateIban(cleaned)) return null;
    try {
        const res = await fetch(
            `https://openiban.com/validate/${encodeURIComponent(cleaned)}?getBIC=true&validateBankCode=true`,
        );
        if (!res.ok) return null;
        const data: OpenIbanResponse = await res.json();
        return data.valid && data.bankData?.bic ? data.bankData.bic : null;
    } catch {
        return null;
    }
}
